<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <cr-combine-price />
      </div>
    </div>
</section>
</template>

<script>
import crCombinationPrice from './Temp/CrCombinationPriceTemp.vue'

export default {
  name: 'Tables',
  components: {
    'cr-combine-price': crCombinationPrice
  },
  methods: {
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// UpCombinationPrice.vue?e72dab24